
export default class Parametro {
    id: number;
    sigla: string;
    nome: string;
    descricao: string;
    tipo: string;

    constructor(
        id: number = 0,
        sigla: string = "",
        nome: string = "",
        descricao: string = "",
        tipo: string = ""
    ) {
        this.id = id;
        this.sigla = sigla;
        this.nome = nome;
        this.descricao = descricao;
        this.tipo = tipo;
    }
}